import { getFetchWrapper } from "@syf-api-library/core";
import { creditAccountsUrl } from "../endpoints.js";
const queryFnFactory = (config) => {
  const fetchWrapper = getFetchWrapper(config);
  return () => {
    const correlationId = sessionStorage.getItem("correlationId") || "";
    return fetchWrapper(`${creditAccountsUrl}`, {
      method: "GET",
      headers: {
        "X-SYF-SessionId": correlationId
      }
    });
  };
};
export {
  queryFnFactory as default
};
//# sourceMappingURL=query.js.map
